import { observer } from "mobx-react-lite";
import React from "react";
import { HeroDataInfo, ScreenResponsive } from "../../components/organisms";
import {
	Box,
	ButtonLayout,
	Callout,
	Grid,
	GridItem,
	IconInformationUserRegular,
	IconShieldCheckedOkLight,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import { Button } from "../../components/atoms";
import { strings } from "../../localization";
import { useNavigateCustom } from "../../hooks";

const SignInInfo: React.FC = observer(() => {
	const { isMobile, isDesktopOrBigger } = useScreenSize();
	const navigate = useNavigateCustom();
	const { title, description, callout } = strings.pages.signInInfo;
	const { buttonPrimary } = strings.components.buttons;

	const navigateToLogin = (): void => {
		navigate("/", { replace: true });
		navigate("/login", { replace: true });
	};

	return (
		<ScreenResponsive>
			<Grid columns={isDesktopOrBigger ? 4 : 1} justifyContent="center">
				<GridItem columnStart={2} span={isDesktopOrBigger ? 2 : 1}>
					<Box width={isDesktopOrBigger ? 600 : "100%"} paddingY={isMobile ? 32 : 40}>
						<HeroDataInfo
							icon={<IconShieldCheckedOkLight color={skinVars.colors.brand} size={64} />}
							title={title}
							description={description}
						/>
						<Grid columns={{ maxSize: 392, minSize: 327 }} justifyContent="center">
							<Box paddingTop={isMobile ? 24 : 40} paddingBottom={isMobile ? 32 : 40}>
								<Callout
									icon={<IconInformationUserRegular color={skinVars.colors.brand} size={24} />}
									description={callout}
								/>
							</Box>
							<Box paddingBottom={isDesktopOrBigger ? 80 : 0}>
								<ButtonLayout>
									<Button textButton={buttonPrimary} onAction={navigateToLogin} />
								</ButtonLayout>
							</Box>
						</Grid>
					</Box>
				</GridItem>
			</Grid>
		</ScreenResponsive>
	);
});

export default SignInInfo;
